/**
 * WEARTH homepage intro — Vogue editorial: readable typewriter, full-line hold, unified exit.
 * Fixes empty-frame dwell: copy stays visible until the whole overlay fades together.
 */
(function () {
  "use strict";

  function safeDismiss() {
    try {
      if (document.body) document.body.classList.add("wearth-intro-seen");
    } catch (e0) {}
    try {
      var el = document.querySelector("[data-wearth-intro]");
      if (el) {
        el.classList.add("wearth-intro-typing-done");
        el.classList.add("wearth-intro-done");
      }
    } catch (e1) {}
    try {
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.setItem("wearth_intro_seen", "1");
      }
    } catch (e2) {}
  }

  try {
    if (typeof document === "undefined" || !document.querySelector) return;

    var root = document.querySelector("[data-wearth-intro]");
    if (!root) return;

    function isPaidSocialEntry() {
      try {
        var ref = (document.referrer || "").toLowerCase();
        var qs = (location.search || "").toLowerCase();
        if (/instagram|facebook|fb\.com|l\.instagram|fb\.me/.test(ref)) return true;
        if (/utm_source=(facebook|fb|ig|instagram)|fbclid=|utm_medium=paid/.test(qs)) return true;
      } catch (ePs) {}
      return false;
    }

    try {
      if (
        !isPaidSocialEntry() &&
        typeof sessionStorage !== "undefined" &&
        sessionStorage.getItem("wearth_intro_seen") === "1"
      ) {
        document.body.classList.add("wearth-intro-seen");
        return;
      }
    } catch (e3) {}

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      safeDismiss();
      return;
    }

    var line =
      root.querySelector("[data-wearth-intro-line]") || root.querySelector(".wearth-intro-line");
    if (!line) {
      safeDismiss();
      return;
    }

    var fullText = "They are\nwearing.";
    var frameReadyMs = 520;
    var charMs = 72;
    var spaceExtraMs = 88;
    var newlinePauseMult = 2.2;
    var periodExtraMs = 110;
    var minDwellAfterCompleteMs = 1650;
    var fadeOutMs = 880;

    if (window.matchMedia && window.matchMedia("(max-width: 749px)").matches) {
      frameReadyMs = 580;
      charMs = 78;
      spaceExtraMs = 96;
      minDwellAfterCompleteMs = 1750;
    }

    function delayForChar(ch) {
      if (!ch) return charMs;
      if (ch === "\n") return Math.round(charMs * newlinePauseMult);
      if (ch === " ") return charMs + spaceExtraMs;
      if (ch === ".") return charMs + periodExtraMs;
      return charMs;
    }

    function cumulativeMs(count) {
      var t = 0;
      for (var i = 0; i < Math.min(count, fullText.length); i++) {
        t += delayForChar(fullText.charAt(i));
      }
      return t;
    }

    var totalTypeMs = cumulativeMs(fullText.length);
    var phaseEndMs = frameReadyMs + totalTypeMs + minDwellAfterCompleteMs;
    var t0 = 0;
    var rafId = null;
    var finished = false;

    function finishSequence() {
      if (finished) return;
      finished = true;
      if (rafId != null) {
        try {
          if (typeof cancelAnimationFrame === "function") cancelAnimationFrame(rafId);
          else clearTimeout(rafId);
        } catch (e6) {}
        rafId = null;
      }
      try {
        line.textContent = fullText;
        line.classList.remove("is-typing");
        line.classList.add("is-hold");
        root.classList.add("wearth-intro-typing-done");
      } catch (e7) {}
      try {
        root.classList.add("wearth-intro-done");
      } catch (e8) {}
      window.setTimeout(function () {
        try {
          if (document.body) document.body.classList.add("wearth-intro-seen");
        } catch (e9) {}
        try {
          sessionStorage.setItem("wearth_intro_seen", "1");
        } catch (e10) {}
      }, fadeOutMs);
    }

    function nowMs() {
      try {
        if (performance && performance.now) return performance.now();
      } catch (e11) {}
      return Date.now();
    }

    function tick() {
      if (finished) return;
      try {
        var elapsed = Math.max(0, nowMs() - t0);

        if (elapsed < frameReadyMs) {
          line.textContent = "";
          line.classList.remove("is-typing", "is-hold");
        } else {
          var typeElapsed = elapsed - frameReadyMs;
          if (typeElapsed < totalTypeMs) {
            var n = 0;
            for (var c = 1; c <= fullText.length; c++) {
              if (cumulativeMs(c) <= typeElapsed) n = c;
              else break;
            }
            line.textContent = fullText.slice(0, n);
            line.classList.add("is-typing");
            line.classList.remove("is-hold");
          } else if (elapsed < phaseEndMs) {
            line.textContent = fullText;
            line.classList.remove("is-typing");
            line.classList.add("is-hold");
          } else {
            finishSequence();
            return;
          }
        }

        if (elapsed >= phaseEndMs) {
          finishSequence();
          return;
        }
        rafId =
          typeof requestAnimationFrame === "function"
            ? requestAnimationFrame(tick)
            : setTimeout(tick, 32);
      } catch (e12) {
        safeDismiss();
      }
    }

    line.textContent = "";
    line.classList.remove("is-typing", "is-hold");
    t0 = nowMs();
    rafId =
      typeof requestAnimationFrame === "function"
        ? requestAnimationFrame(tick)
        : setTimeout(tick, 32);
  } catch (outer) {
    safeDismiss();
  }
})();
